import {Stack, TextField, Typography} from "@mui/material";
import LoadingButton from "@/global/components/LoadingButton";
import React, {type ChangeEvent} from "react";

interface Props {
    iin: string;
    handleIinChange: (e: ChangeEvent<HTMLInputElement>) => void,
    handleFetchStudents: () => void,
    studentsByIINLoading: boolean,
}

export function IinApplicationStep({
                                 iin,
                                 handleIinChange,
                                 handleFetchStudents,
                                 studentsByIINLoading
                             }: Props) {

    return (
        <Stack
            width={{lg: '60%', xs: '100%'}}
            flexDirection={'column'}
            gap={2}
            sx={{
                margin: '0 auto',
                p: 4,
                borderRadius: '26px',
                background: '#F5F5F5',
                gap: '16px'
            }}
        >
            <Stack gap={1}>
                <Typography>
                    ИИН:
                </Typography>
                <TextField
                    name={'iin'}
                    fullWidth
                    value={iin}
                    onChange={handleIinChange}
                    placeholder={'123 456 789 123'}
                    sx={{
                        borderRadius: '10px',
                        '.MuiOutlinedInput-root': {
                            backgroundColor: '#ebf0fb',
                        },
                        '.MuiOutlinedInput-input': {
                            color: '#05304F',
                            padding: '18px',
                            fontSize: '16px',
                            lineHeight: '24px',
                        },
                        '.MuiOutlinedInput-notchedOutline': {
                            borderColor: 'transparent'
                        }
                    }}
                />
            </Stack>

            <LoadingButton
                variant={'contained'}
                sx={{
                    px: '50px',
                    textTransform: 'none',
                }}
                disabled={!iin}
                loading={studentsByIINLoading}
                onClick={handleFetchStudents}
            >
                Получить информацию о пунктах сдачи
            </LoadingButton>
        </Stack>
    );
}